/**
 * Bundled source locale and i18next fallback. English is always shipped in-app
 * (`public/locales/en-US/`) and is never loaded from the translations CDN.
 */
export const PRIMARY_LANGUAGE = "en-US";

export function isPrimaryLanguage(locale: string): boolean {
  return locale === PRIMARY_LANGUAGE;
}

/** Locales list containing only the primary language (common i18n fallback). */
export const PRIMARY_LANGUAGE_LOCALES: readonly string[] = [PRIMARY_LANGUAGE];

export function withPrimaryLanguage(locales: readonly string[]): string[] {
  return [...new Set([PRIMARY_LANGUAGE, ...locales])];
}
